import PropTypes from "prop-types";
import React from "react";
import { Link } from "gatsby";

const Breadcrumb = ({
  title,
  content,
  contentTwo,
  image,
  isBreadcrumb,
  opacity,
}) => {
  return (
    <div
      className="page-title-section section section-padding-top"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="my-overlay" style={{ opacity: opacity && opacity }} />
      <div className="page-title">
        <div className="container">
          <h1 className="title" style={{ color: title?.color?.hex }}>
            {title?.text}
          </h1>
        </div>
      </div>
      {isBreadcrumb && (
        <div className="page-breadcrumb position-static">
          <div className="container">
            <ul className="breadcrumb justify-content-center">
              <li>
                <Link to={"/"} style={{ color: contentTwo?.color?.hex }}>
                  {content}
                </Link>
              </li>
              <li className="current" style={{ color: contentTwo?.color?.hex }}>
                {contentTwo?.text}
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

Breadcrumb.propTypes = {
  title: PropTypes.object,
  content: PropTypes.string,
  contentTwo: PropTypes.object,
  image: PropTypes.string,
};

export default Breadcrumb;
